import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import api from "../../../services/api";
import Loader from "../../../core/common/loader";
import { showBasicAlert } from "../../../core/common/useAlert";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import CommonSelect from "../../../core/common/commonSelect";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import {
  Modal,
  Button,
  Select,
  DatePicker,
  Table as Tables,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
const { RangePicker } = DatePicker;

const DealTransfer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let previousSelectedCompanyDetails = location.state?.companyDetails || null;
  let previousSelectedformDetails = location.state?.formDetails || null;
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  const [fromUserId, setFromUserId] = useState<number | null>(null);
  const [toUserId, setToUserId] = useState<number | null>(null);
  const [userLeads, setUserLeads] = useState<any[]>([]);
  const [pipelineFilter, setPipelineFilter] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs | null, dayjs.Dayjs | null]
  >([null, null]);
  const [selectedLeads, setSelectedLeads] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [filterTransferData, setFilterTransferData] = useState(data);
  const [getAllCompanyLists, setgetAllCompanyList] = useState<any[]>([]);
  const [dataForm, setdataForm] = useState<any[]>([]);
  const [pipelines, setPipelines] = useState<any[]>([]); // Pipeline Stages (e.g., Not Contacted, Contacted)

  const companyChoose = [
    ...getAllCompanyLists?.map((company: any) => ({
      value: company.id,
      label: company.name + " - " + company.type,
    })),
  ];

  var initialFormDataChooseCompany = {
    signature: signature,
    companyName: "Select Company",
    companyId: "",
    companyType: "Deals",
  };
  const [formDataCompanyChoose, setformDataCompanyChoose] = useState(
    initialFormDataChooseCompany
  );

  const handleCompanyChange = async (selectedOption: any) => {
    if (
      !selectedOption ||
      selectedOption.value == "" ||
      selectedOption.value == undefined
    )
      return;

    const newFormData = {
      companyId: selectedOption.value,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: selectedOption.label.split("-")[1].trim(),
    };

    setformDataCompanyChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    try {
      const [getLeadForms, getLeadSettings] = await Promise.all([
        api.post("leadService/getLeadFormsByCompany", {
          signature,
          company_id: newFormData.companyId,
          company_type: newFormData.companyType,
        }),
        api.post("leadService/getAllLeadSettings", {
          signature,
          company_id: parseInt(newFormData.companyId),
          company_type: newFormData.companyType,
        }),
      ]);

      const [responseUser] = await Promise.all([
        api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            getLeadSettings?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(newFormData.companyId),
          company_type: newFormData.companyType,
        }),
      ]);

      setdataForm(getLeadForms.data.data.data);
      setUsers(responseUser.data?.data?.data?.allUsers || []);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    }
  };

  useEffect(() => {
    if (
      dataForm.length &&
      previousSelectedformDetails &&
      previousSelectedformDetails != null
    ) {
      handleFormChange({
        value:
          previousSelectedformDetails?.pipeline_id +
          "-" +
          previousSelectedformDetails?.form_id,
        label: previousSelectedformDetails?.form_name,
      });
    } else if (dataForm.length) {
      handleFormChange({
        value: dataForm[0].pipeline_id + "-" + dataForm[0].key,
        label: dataForm?.[0]?.LeadFormName,
      });
    } else {
      handleFormChange({
        value: "",
        label: "No Deal Form",
      });
      setIsLoading(false);
    }
  }, [dataForm]);

  const formChoose = [
    ...dataForm?.map((form: any) => ({
      value: form.deal_pipeline_id + "-" + form.key,
      label: form.LeadFormName,
    })),
  ];

  var initialFormDataChooseForm = {
    signature: signature,
    pipeline_id: "Select Form",
    form_name: "",
    form_id: "",
  };
  const [formDataFormChoose, setformDataFormChoose] = useState(
    initialFormDataChooseForm
  );

  const handleFormChange = async (selectedOption: any) => {
    if (!selectedOption || selectedOption.value == "") {
      const newFormData = {
        pipeline_id: selectedOption.value?.split("-")[0],
        form_name: selectedOption.label,
        form_id: selectedOption.value?.split("-")[1],
      };
      setformDataFormChoose((prev: any) => ({
        ...prev,
        ...newFormData,
      }));
      return;
    }
    const newFormData = {
      pipeline_id: selectedOption.value?.split("-")[0],
      form_name: selectedOption.label,
      form_id: selectedOption.value?.split("-")[1],
    };
    setformDataFormChoose((prev: any) => ({
      ...prev,
      ...newFormData,
    }));

    try {
      const [pipelineList] = await Promise.all([
        api.post("leadService/getAllPipelinesById", {
          signature,
          id: newFormData.pipeline_id,
        }),
      ]);
      setPipelines(pipelineList.data.data.data);

      navigate(
        {
          pathname: location.pathname,
          search: location.search,
        },
        {
          replace: true,
          state: {
            ...location.state,
            companyDetails: undefined,
            formDetails: undefined,
          },
        }
      );
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    }
  };

  useEffect(() => {
    updateUI(formDataCompanyChoose);
  }, [formDataFormChoose, pipelines]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setIsLoading(true);
        const [getAllCompanyList] = await Promise.all([
          api.post("userService/getAllCompanyList", { signature }),
        ]);
        setgetAllCompanyList(getAllCompanyList.data.data.data);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (!fromUserId) {
      setUserLeads([]);
      return;
    }
    const leads = data.filter((lead) => lead.assigned_to === fromUserId);
    setUserLeads(leads);
    setSelectedLeads([]);
    setPipelineFilter(null);
    setDateRange([null, null]);
  }, [fromUserId, data]);

  const pipelineOptions = [
    { label: "All Pipelines", value: null },
    ...Array.from(new Set(userLeads.map((lead) => lead.pipeline_char))).map(
      (p) => ({
        label: p,
        value: p,
      })
    ),
  ];

  const filteredLeads = userLeads.filter((lead) => {
    const matchPipeline = pipelineFilter
      ? lead.pipeline_char === pipelineFilter
      : true;
    const matchDate =
      dateRange[0] && dateRange[1]
        ? dayjs(lead.createdAt, "M/D/YYYY, h:mm:ss A").isBetween(
            dateRange[0].startOf("day"),
            dateRange[1].endOf("day"),
            null,
            "[]"
          )
        : true;
    const matchSearch = searchTerm
      ? lead.LeadName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.Phone?.toLowerCase().includes(searchTerm.toLowerCase())
      : true;

    return matchPipeline && matchDate && matchSearch;
  });

  useEffect(() => {
    if (previousSelectedCompanyDetails != null) {
      handleCompanyChange({
        value: previousSelectedCompanyDetails?.companyId,
        label:
          previousSelectedCompanyDetails?.companyName +
          "-" +
          previousSelectedCompanyDetails?.companyType,
      });
    } else {
      handleCompanyChange({
        value: getAllCompanyLists?.[0]?.id,
        label:
          getAllCompanyLists?.[0]?.name + "-" + getAllCompanyLists?.[0]?.type,
      });
    }
  }, [getAllCompanyLists]);

  const updateUI = async (data: any) => {
    if (
      data.companyId == "" ||
      pipelines.length == 0 ||
      formDataFormChoose.form_id == "" ||
      formDataFormChoose.form_id == undefined
    ) {
      setData([]);
      setFilterTransferData([]);
      return;
    }
    setIsLoading(true);
    var fetchedLeads;
    var transferHistory;
    [fetchedLeads, transferHistory] = await Promise.all([
      api.post("leadService/getAllDealsResponse", {
        signature,
        company_id: data.companyId,
        company_type: data.companyType,
        start_date: moment().subtract(1, "year").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        form_id: formDataFormChoose.form_id,
      }),
      api.post("leadService/getTransferDeals", {
        signature,
        company_id: data.companyId,
        company_type: data.companyType,
        form_id: formDataFormChoose.form_id,
      }),
    ]);
    var response = fetchedLeads.data.data.data;
    var responseTransfer = transferHistory.data.data.data;
    const filteredLeads = response.filter(
      (item: any) =>
        parseInt(item.pipeline_id) === parseInt(formDataFormChoose.pipeline_id)
    );
    setData(filteredLeads);
    setFilterTransferData(responseTransfer);
    setIsLoading(false);
  };

  const routes = all_routes;
  const columns = [
    {
      title: "Deal Id",
      dataIndex: "lead_id",
    },
    {
      title: "Deal Name",
      dataIndex: "Name",
    },
    {
      title: "Phone",
      dataIndex: "MobileNo",
    },
    {
      title: "Last Pipeline",
      dataIndex: "Stage",
    },
    {
      title: "Transfer Date",
      dataIndex: "TransferDate",
      render: (text: string) => moment(text).format("DD-MM-YYYY hh:mm A"),
      sorter: (a: any, b: any) =>
        new Date(a.TransferDate).getTime() - new Date(b.TransferDate).getTime(),
    },
    {
      title: "Transfer From",
      dataIndex: "From",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link
            to="#"
            onClick={(e: any) => e.preventDefault()}
            className="avatar avatar-md border rounded-circle d-flex align-items-center justify-content-center bg-light text-dark fw-bold">
            {record.ToImage &&
            record.ToImage.trim() !== "" &&
            record.ToImage.trim() !== "null" ? (
              <ImageWithBasePath
                src={record.FromImage}
                className="img-fluid rounded-circle"
                alt="img"
              />
            ) : (
              <span>{text?.charAt(0)?.toUpperCase() || "U"}</span>
            )}
          </Link>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#" onClick={(e: any) => e.preventDefault()}>
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
    },
    {
      title: "Transfer To",
      dataIndex: "To",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link
            to="#"
            onClick={(e: any) => e.preventDefault()}
            className="avatar avatar-md border rounded-circle d-flex align-items-center justify-content-center bg-light text-dark fw-bold">
            {record.ToImage &&
            record.ToImage.trim() !== "" &&
            record.ToImage.trim() !== "null" ? (
              <ImageWithBasePath
                src={record.ToImage}
                className="img-fluid rounded-circle"
                alt="img"
              />
            ) : (
              <span>{text?.charAt(0)?.toUpperCase() || "U"}</span>
            )}
          </Link>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#" onClick={(e: any) => e.preventDefault()}>
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
    },
  ];

  const columnsTable = [
    {
      title: (
        <Checkbox
          checked={
            filteredLeads.length > 0 &&
            filteredLeads.every((lead) => selectedLeads.includes(lead.key))
          }
          indeterminate={
            filteredLeads.some((lead) => selectedLeads.includes(lead.key)) &&
            !filteredLeads.every((lead) => selectedLeads.includes(lead.key))
          }
          onChange={(e) => {
            const visibleIds = filteredLeads.map((lead) => lead.key);

            if (e.target.checked) {
              // Add all visible IDs to selectedLeads
              const merged = Array.from(
                new Set([...selectedLeads, ...visibleIds])
              );
              setSelectedLeads(merged);
            } else {
              // Remove all visible IDs from selectedLeads
              const remaining = selectedLeads.filter(
                (id) => !visibleIds.includes(id)
              );
              setSelectedLeads(remaining);
            }
          }}
        />
      ),
      dataIndex: "select",
      render: (_: any, record: any) => (
        <Checkbox
          checked={selectedLeads.includes(record.key)}
          onChange={() => {
            const id = record.key;
            setSelectedLeads((prev) =>
              prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
            );
          }}
        />
      ),
      width: 50,
    },

    {
      title: "Name",
      dataIndex: "LeadName",
      width: 130,
      ellipsis: true,
      key: "LeadName",
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      width: 130,
      ellipsis: true,
      key: "Phone",
    },
    {
      title: "Pipeline",
      dataIndex: "pipeline_char",
      width: 180,
      ellipsis: true,
      key: "pipeline_char",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      width: 130,
      ellipsis: true,
      key: "createdAt",
      render: (value: string) =>
        moment(value, "M/D/YYYY, h:mm:ss A").format("DD-MM-YYYY"),
    },
  ];

  const refreshPage = async () => {
    updateUI(formDataCompanyChoose);
  };

  const handleTransfer = async () => {
    if (!fromUserId || !toUserId) {
      showBasicAlert("Please select both users.");
      return;
    }
    if (fromUserId === toUserId) {
      showBasicAlert("Cannot transfer to the same user.");
      return;
    }

    if (selectedLeads.length == 0) {
      showBasicAlert("Please select leads for transfer");
      return;
    }

    Modal.confirm({
      title: "Confirm Deal Transfer",
      content: `Are you sure you want to transfer ${selectedLeads.length} leads ?`,
      okText: "Yes, Transfer",
      cancelText: "Cancel",
      centered: true,
      onOk: async () => {
        try {
          await api.post("leadService/transferDeals", {
            signature,
            from_user_id: fromUserId,
            to_user_id: toUserId,
            company_id: formDataCompanyChoose.companyId,
            company_type: formDataCompanyChoose.companyType,
            form_id: formDataFormChoose.form_id,
            selectedLeads: selectedLeads,
          });
          showBasicAlert("Deals transferred successfully!");
          refreshPage();
        } catch (error) {
          showBasicAlert("Transfer failed");
        }
      },
    });
  };

  return (
    <>
      {isLoading && <Loader />}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">👤 🔁 Deals Transfer</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">CRM</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Deals Transfer
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={formChoose}
                  defaultValue={{
                    value: `${formDataFormChoose.pipeline_id}-${formDataFormChoose.form_id}`,
                    label: formDataFormChoose.form_name,
                  }}
                  onChange={handleFormChange}
                />
              </div>

              <div className="dropdown me-2 mb-2">
                <CommonSelect
                  className="select"
                  options={companyChoose}
                  defaultValue={{
                    value: formDataCompanyChoose.companyId,
                    label:
                      formDataCompanyChoose.companyName +
                      "-" +
                      formDataCompanyChoose.companyType,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div className="me-2 mb-2">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => setShowTransferModal(true)}>
                  <i className="ti ti-repeat me-2" />
                  Transfer Deals
                </button>
              </div>

              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leads List */}
          <div>
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4">
              <h5>Deal List</h5>
            </div>
            <div className="p-0">
              <Table
                key={JSON.stringify(filterTransferData)}
                dataSource={filterTransferData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
          {/* /Leads List */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>

      <Modal
        open={showTransferModal}
        centered
        onCancel={() => {
          setFromUserId(null);
          setToUserId(null);
          setPipelineFilter(null);
          setDateRange([null, null]);
          setShowTransferModal(false);
        }}
        style={{ width: "95%", maxWidth: 1000 }} // Responsive width
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setFromUserId(null);
              setToUserId(null);
              setPipelineFilter(null);
              setDateRange([null, null]);
              setShowTransferModal(false);
            }}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleTransfer}>
            Transfer
          </Button>,
        ]}>
        <div style={{ marginBottom: 16 }}>
          <label>
            <strong>Transfer From:</strong>
          </label>
          <Select
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Select user to transfer from"
            onChange={setFromUserId}
            options={users.map((u) => ({
              value: u.key,
              label: u.Name,
            }))}
            value={fromUserId}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label>
            <strong>Transfer To:</strong>
          </label>
          <Select
            style={{ width: "100%", marginTop: 8 }}
            placeholder="Select user to transfer to"
            onChange={setToUserId}
            options={users.map((u) => ({
              value: u.key,
              label: u.Name,
            }))}
            value={toUserId}
          />
        </div>

        {fromUserId && (
          <>
            <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: "block", marginBottom: 4 }}>
                  <strong>Pipeline</strong>
                </label>
                <Select
                  allowClear
                  placeholder="Filter by Pipeline"
                  style={{ width: "100%", height: 40 }}
                  options={pipelineOptions}
                  onChange={setPipelineFilter}
                  value={pipelineFilter}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label style={{ display: "block", marginBottom: 4 }}>
                  <strong>Date</strong>
                </label>
                <RangePicker
                  value={dateRange}
                  onChange={(dates) => setDateRange(dates ?? [null, null])}
                  allowClear
                  style={{ width: "100%", height: 40 }}
                />
              </div>
            </div>

            <div
              style={{
                maxHeight: 300,
                overflowY: "auto",
                border: "1px solid #eee",
                borderRadius: 8,
                padding: 12,
                backgroundColor: "#fdfdfd",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}>
              <div style={{ marginBottom: 12 }}>
                <input
                  type="text"
                  placeholder="Search by name or mobile number"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: 6,
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              <Tables
                columns={columnsTable}
                dataSource={filteredLeads}
                pagination={{ pageSize: 10 }}
                rowKey="key"
                bordered
                size="middle"
              />
            </div>

            <p style={{ marginTop: 8 }}>
              Selected Deals: <strong>{selectedLeads.length}</strong>
            </p>
          </>
        )}
      </Modal>
    </>
  );
};

export default DealTransfer;
